// extracted by mini-css-extract-plugin
export default {"Detail":"Index_Detail__JI6zB"};